const noop = () => {};
let  __message__ = {};
let isCover = false;
const EventBind = {
    // 注册事件
    addEventListener(type, fn = noop) {
        let curEvent = __message__[type];
        if (Object.prototype.toString.call(curEvent) === '[object Undefined]' || isCover) {
            curEvent = [fn];
        } else {
            // 是否已经添加了相同的listener
            if (!curEvent.includes(fn)) {
                curEvent.push(fn);
            }
        }
        __message__[type] = curEvent;
    },

    // 发布消息接口
    emitEvent(type, args) {
        // 当消息不存在时直接返回
        if (!__message__[type]) {
            return;
        }

        args = args || {};
        // 依次执行消息对应的动作队列
        if (__message__[type]) {
            for (let i = 0, len = __message__[type].length; i < len; i++) {
                __message__[type]&&__message__[type][i].call(this, args);
            }
        }
        
    },

    // 移除事件监听的处理函数
    removeEventListener(type, fn) {
        if (__message__[type]) {
            __message__[type] = __message__[type].filter((item) => item !== fn);
            if (__message__[type].length === 0) {
                delete __message__[type];
            }
        }
    },

    // 清除特定的某一类监听事件
    removeEventListenerAllByType(type) {
        delete __message__[type];
    },

    // 清除所有监听事件
    removeEventListenerAll() {
        __message__ = {};
    },

    // 获取某一类型的listener
    getEventListenerListByType(type) {
        return __message__[type];
    },
    // 获取所有绑定listener的事件名称
    getEventTypes() {
        return Object.keys(__message__);
    }
}
export default EventBind;